const SESSION_KEY = "biome_user_session";
const SESSION_DURATION_MS = 24 * 60 * 60 * 1000;

export const getUserSession = () => {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    if (!raw) return null;

    const session = JSON.parse(raw);
    if (!session?.expiresAt || Date.now() > session.expiresAt) {
      localStorage.removeItem(SESSION_KEY);
      return null;
    }

    return session;
  } catch {
    localStorage.removeItem(SESSION_KEY);
    return null;
  }
};

export const isUserRegistered = () => Boolean(getUserSession());

export const setUserSession = ({ name, email, mobile }) => {
  const session = {
    name,
    email,
    mobile,
    registeredAt: Date.now(),
    expiresAt: Date.now() + SESSION_DURATION_MS,
  };

  localStorage.setItem(SESSION_KEY, JSON.stringify(session));
};
